export class Addon {
  constructor() {}

  id: string;
  projectName: string;
  projectImg: string;
  snapshots: string[];
  scenery: string;
  railing: any;
  railingColors: any;
  projectType: string;
  userId: string;
  sceneId: string;
  created: Date;
  updated: Date;
}



// WEBPACK FOOTER //
// ./src/app/classes/addon.ts